export enum ParticipantRoles {
    organiser = "organiser",
    admin = "admin",
    sharer = "sharer"
}
